.card { background: var(--color-surface); border: 1px solid var(--color-border); border-radius: var(--radius-xl); box-shadow: var(--shadow-xs); }
.interactive { transition: border-color var(--duration-fast), box-shadow var(--duration-base), transform var(--duration-base); }
.interactive:hover { border-color: var(--color-border-strong); box-shadow: var(--shadow-md); }
.interactive:active { transform: translateY(1px); }
.pad-none { padding: 0; }
.pad-sm { padding: var(--space-3); }
.pad-md { padding: var(--space-5); }
.pad-lg { padding: var(--space-6); }
.header { display: flex; align-items: flex-start; justify-content: space-between; gap: var(--space-3); margin-bottom: var(--space-4); }
.title { font-size: var(--text-md); font-weight: var(--weight-semibold); }
.subtitle { margin-top: 2px; font-size: var(--text-sm); color: var(--color-text-tertiary); }
.section + .section { border-top: 1px solid var(--color-border); }
.section { padding: var(--space-4) var(--space-5); }
